var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedStepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 0.0859375C5.41855 0.0859375 0.0831299 5.42135 0.0831299 12.0026C0.0831299 18.5839 5.41855 23.9193 11.9998 23.9193C18.581 23.9193 23.9165 18.5839 23.9165 12.0026C23.9165 5.42135 18.581 0.0859375 11.9998 0.0859375ZM17.1651 9.98761C17.2602 9.87888 17.3326 9.75224 17.3781 9.61512C17.4235 9.478 17.4411 9.33318 17.4298 9.18917C17.4184 9.04516 17.3784 8.90488 17.312 8.77658C17.2456 8.64827 17.1543 8.53453 17.0433 8.44206C16.9323 8.34958 16.804 8.28023 16.6658 8.23809C16.5276 8.19595 16.3824 8.18186 16.2388 8.19667C16.0951 8.21147 15.9558 8.25486 15.8291 8.32429C15.7024 8.39372 15.5909 8.48778 15.5011 8.60094L10.8428 14.1899L8.43238 11.7784C8.22806 11.581 7.95441 11.4718 7.67036 11.4743C7.38631 11.4768 7.1146 11.5907 6.91374 11.7916C6.71288 11.9924 6.59895 12.2641 6.59648 12.5482C6.59401 12.8322 6.70321 13.1059 6.90055 13.3102L10.1505 16.5602C10.257 16.6666 10.3844 16.7496 10.5247 16.804C10.6651 16.8584 10.8152 16.883 10.9655 16.8761C11.1158 16.8693 11.2631 16.8312 11.3979 16.7643C11.5327 16.6974 11.6521 16.6032 11.7485 16.4876L17.1651 9.98761Z",
    fill: "#079F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedStepIcon);
export default __webpack_public_path__ + "static/media/completed-step-icon.d01389c5617081c062068fb826eaafa8.svg";
export { ForwardRef as ReactComponent };